import { Header } from 'modules/checkout/presentation/components/molecules';
import { StatusInformation } from 'modules/checkout/presentation/components/organisms';
import { AllRightsFooter } from 'shared/presentation/components/atoms';
import { ANIMATIONS, TIconType } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';

import * as S from './styles';

interface IAction {
  text: string;
  icon: TIconType;
  onClick: () => void;
}

interface ICheckoutInfoProps {
  message: string;
  actions?: IAction[];
}

const CheckoutInfo: React.FC<ICheckoutInfoProps> = ({
  message,
  actions = [],
}) => {
  const { t } = useLocale('checkout');

  return (
    <S.Container>
      <Header />

      <StatusInformation
        animation={{
          data: ANIMATIONS.PENDING,
          width: 260,
          height: 260,
        }}
        loop={false}
        title={t('Processing your payment')}
        message={message}
        actions={actions}
      />

      <AllRightsFooter />
    </S.Container>
  );
};

export default CheckoutInfo;
